<template lang='pug'>
  v-content
    v-container(fluid)
      v-flex
        v-card
          v-toolbar(color='white')
            v-toolbar-title(v-model="title") {{ title }}
            v-divider(class="mx-2" inset vertical)
            v-spacer
            v-btn(color="error" @click="addNewPengawalan" class="mx-2") Tambah Pengawalan
            v-btn(color="primary" @click="addNewLampiran") Tambah Lampiran
          v-divider
          AttachmentList(:title='title' :dialogType='dialogType' @selectedAttachment="updateAttachment" :ip='getIp()')
</template>

<script>
import * as config from "../config/index.json";
import AttachmentList from "@/components/AttachmentList.vue";
import { mapState } from "vuex";
import helper from "../helper/index.js";
export default {
  name: "MyAttachment",
  components: {
    AttachmentList
  },
  data () {
    return {
      config: config.default,
      title: 'List Lampiran Pengawalan',
      dialogType: 'creator',
      ip: {
        headers: [
          {
            text: 'Judul',
            align: 'start',
            sortable: false,
            value: 'ipTitle',
          },
          { text: 'Tanggal', value: 'ipDateFormat' },
          { text: 'Perusahaan', value: 'ipPerusahaan' },
          { text: 'Jenis Kendaraan', value: 'ipJenisKendaraan' },
          { text: 'Model Kendaraan', value: 'ipModelKendaraan' },
          { text: 'Status', value: 'ipStatusLabel', align: 'center', width: '120px'},
          { text: 'Action', value: 'actions' },
          { text: '', value: 'data-table-expand' }
        ],
        items: []
      },
      selectedAttachment: [],    
    }
  },
  mounted () {
    this.$store.dispatch("fetchMyAttachment");
  },
  computed: {
    ...mapState(["myAttachment"])
  },
  methods: {
    addNewLampiran() {
      this.$router.push('/add-lampiran-pengawalan');
    },
    addNewPengawalan() {
      this.$store.commit("setSelectedAttachment", this.selectedAttachment);
      this.$router.push('/add-izin-pengawalan?list=1');
    },
    getIp(){
      this.ip.items = this.myAttachment;
      for (let i = 0; i < this.ip.items.length; i++) {
        this.ip.items[i].ipStatusLabel = this.config.status[this.ip.items[i].ipStatus].name;
        this.ip.items[i].ipStatusColor = this.ip.items[i].ipStatus;
        this.ip.items[i].ipDateFormat = this.formatDate(this.ip.items[i].ipDate);
        this.ip.items[i].isSelectable = this.ip.items[i].ipStatus == 4;
      }
      return this.ip;
    },
    updateAttachment(attachmentData) {
      this.selectedAttachment = attachmentData;
    },
    getWITADate:helper.getWITADate,
    formatDate:helper.formatDate
  }
};
</script>
